/** Dashboard filter selection; removed by `OAuthService.sessionEndLocal`. */
export const DASHBOARD_FILTERS_STORAGE_KEY = 'partner.dashboardFilters';
